import { render, staticRenderFns } from "./AccountantsCustomersMenu.vue?vue&type=template&id=575e3c97&scoped=true&"
import script from "./AccountantsCustomersMenu.vue?vue&type=script&lang=js&"
export * from "./AccountantsCustomersMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575e3c97",
  null
  
)

export default component.exports